var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDeliveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6148 11.3059C14.4042 11.3059 14.2331 11.4769 14.2331 11.6871V17.2861H1.76415V1.7629H14.2331V4.22303C14.2331 4.43481 14.4048 4.60533 14.6148 4.60533C14.8249 4.60533 14.996 4.43431 14.996 4.22303V1.3812C14.996 1.17053 14.825 1 14.6148 1H1.3812C1.17053 1 1 1.17102 1 1.3812V17.6672C1 17.8778 1.17102 18.0495 1.3812 18.0495H14.6148C14.8255 18.0495 14.996 17.8773 14.996 17.6672V11.6876C14.996 11.477 14.8255 11.3059 14.6148 11.3059V11.3059Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5274 6.6436L15.9682 5.08383C15.8247 4.94081 15.571 4.94081 15.4286 5.08383L9.73722 10.7746C9.68934 10.823 9.65521 10.883 9.63765 10.9484L9.09035 13.0549C9.05623 13.1857 9.09477 13.3255 9.19041 13.4212C9.26297 13.4933 9.36032 13.5328 9.45988 13.5328C9.49229 13.5328 9.52422 13.5284 9.55613 13.5202L11.6626 12.9735C11.7286 12.9564 11.7885 12.9218 11.8364 12.8734L17.5275 7.18263C17.6765 7.0347 17.6765 6.79273 17.5275 6.6437L17.5274 6.6436ZM11.3703 12.2608L9.99308 12.6183L10.3506 11.2411L14.4454 7.1463L15.4651 8.1665L11.3703 12.2608ZM16.0044 7.62669L14.9847 6.60699L15.6981 5.89359L16.7178 6.91329L16.0044 7.62669Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.904 3.54688H4.09995C3.88928 3.54688 3.71875 3.71789 3.71875 3.92917C3.71875 4.13984 3.88977 4.31037 4.09995 4.31037H11.904C12.1146 4.31037 12.2857 4.13935 12.2857 3.92917C12.2862 3.71789 12.1145 3.54688 11.904 3.54688Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.286 6.72495C12.286 6.51428 12.1144 6.34375 11.9043 6.34375H4.09995C3.88928 6.34375 3.71875 6.51477 3.71875 6.72495C3.71875 6.935 3.88977 7.10614 4.09995 7.10614H11.904C12.1145 7.10664 12.2861 6.93562 12.2861 6.72495H12.286Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29912 9.14062H4.09995C3.88928 9.14062 3.71875 9.31164 3.71875 9.52292C3.71875 9.73359 3.88977 9.90412 4.09995 9.90412H8.29912C8.50979 9.90412 8.68032 9.7331 8.68032 9.52292C8.68019 9.31115 8.50918 9.14062 8.29912 9.14062Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09995 12.7088H7.45055C7.66171 12.7088 7.83225 12.5367 7.83225 12.3265C7.83225 12.1165 7.66123 11.9453 7.45055 11.9453L4.09995 11.9454C3.88928 11.9454 3.71875 12.1165 3.71875 12.3266C3.71875 12.5367 3.88928 12.7088 4.09995 12.7088V12.7088Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09995 15.5057H11.904C12.1146 15.5057 12.2857 15.3347 12.2857 15.1245C12.2857 14.9144 12.114 14.7422 11.904 14.7422L4.09995 14.7423C3.88928 14.7423 3.71875 14.9144 3.71875 15.1246C3.71875 15.3347 3.88928 15.5057 4.09995 15.5057V15.5057Z",
    fill: "#ffbb00",
    stroke: "#ffbb00",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDeliveredIcon);
export default __webpack_public_path__ + "static/media/order-delivered-icon.6911c6b21d88844dfc8fdfbf9620afbb.svg";
export { ForwardRef as ReactComponent };